import { useEffect } from 'react'

const useAppDynamics = () => {
	useEffect(() => {
		window['adrum-start-time'] = new Date().getTime()

		// Determine environment based on hostname
		let appKey = ''
		const hostname = window.location.hostname
		if (
			hostname.includes('uat') ||
			hostname.includes('sit') ||
			hostname.includes('localhost')
		) {
			appKey = 'AD-AAB-ADY-WHD'
		} else {
			appKey = 'AD-AAB-ADY-WDM'
		}

		;(function (config) {
			config.appKey = appKey
			config.adrumExtUrlHttp = 'http://cdn.appdynamics.com'
			config.adrumExtUrlHttps = 'https://cdn.appdynamics.com'
			config.beaconUrlHttp = 'http://pdx-col.eum-appdynamics.com'
			config.beaconUrlHttps = 'https://pdx-col.eum-appdynamics.com'
			config.useHTTPSAlways = true
			config.resTiming = { bufSize: 200, clearResTimingOnBeaconSend: true }
			config.maxUrlLength = 512
		})(window['adrum-config'] || (window['adrum-config'] = {}))

		const script = document.createElement('script')
		script.src = '//cdn.appdynamics.com/adrum/adrum-24.4.0.4454.js'
		script.async = true
		script.onload = () => console.log('AppDynamics script loaded successfully')
		script.onerror = () => console.error('AppDynamics script failed to load')
		document.head.appendChild(script)
		// Inject Adobe Launch by environment (dev/uat/prod)
		const isLocal = hostname.includes('localhost') || hostname.includes('dev') || hostname.includes('sit')
		const isUat = hostname.includes('uat')
		let adobeLaunchUrl = ''
		if (isLocal) {
			adobeLaunchUrl =
				'https://assets.adobedtm.com/d3b94cb0ef22/e81efd98dce4/launch-3434a60ec319-development.min.js'
		} else if (isUat) {
			adobeLaunchUrl =
				'https://assets.adobedtm.com/d3b94cb0ef22/e81efd98dce4/launch-e37df33289e2-staging.min.js'
		} else {
			adobeLaunchUrl =
				'https://assets.adobedtm.com/d3b94cb0ef22/e81efd98dce4/launch-44eca24ae28f.min.js'
		}
		const adobeScript = document.createElement('script')
		adobeScript.src = adobeLaunchUrl
		adobeScript.async = true
		adobeScript.onload = () => console.log('Adobe Launch script loaded successfully:', adobeLaunchUrl)
		adobeScript.onerror = () => console.error('Adobe Launch script failed to load:', adobeLaunchUrl)
		document.head.appendChild(adobeScript)
	}, [])
}

export default useAppDynamics
